import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Breadcrumb, Card, Row, Col, Button, Modal, Message } from 'antd';

import { Form } from '../../components';
// import image from './screenshot.png';
// import image from './screenshot1.png';
import PageHeaderLayout from '../../layouts/PageHeaderLayout';
import { Home } from '../../models';
// import { s3Host } from '../../utils';
import SortableList from './SortableList';
import styles from './index.less';

const { confirm } = Modal;

const typeOptions = [{
  _id: 'category',
  name: 'Категори',
}, {
  _id: 'new',
  name: 'Шинэ',
}, {
  _id: 'category-structure',
  name: 'Бүх категори 1',
}, {
  _id: 'category-sub',
  name: 'Дэд категори',
}, {
  _id: 'cat',
  name: 'Бүх категори 2',
}, {
  _id: 'type1',
  name: 'Хямдралтай',
}];

class Homepage extends Component {
  static propTypes = {
    home: PropTypes.object,
    list: PropTypes.func.isRequired,
    add: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    order: PropTypes.func.isRequired,
    changeOrder: PropTypes.func.isRequired,
    categories: PropTypes.array,
  }

  static defaultProps = {
    home: {},
    categories: [],
  }

  constructor(props) {
    super(props);
    this.state = {
      formModal: false,
      formData: {},
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh = async () => {
    await this.props.list();
  }

  addHandler = async () => {
    await this.props.add();
  }

  removeHandler = async () => {
    await this.props.remove();
  }

  onSortEnd = async ({ oldIndex, newIndex }) => {
    await this.props.changeOrder({
      oldIndex,
      newIndex,
    });

    await this.props.order({ body: { ids: this.props.home.data.map(entry => entry.id) } });
  }

  onCreate = async () => {
    console.log('created');
  }

  onDelete = async (item) => {
    confirm({
      title: 'Та уг загварыг устгахдаа итгэлтэй байна уу?',
      // content: 'Some descriptions',
      okText: 'Тийм',
      okType: 'danger',
      cancelText: 'Үгүй',
      onOk: async () => {
        await this.props.remove({ body: { id: item.id } });
        Message.success('Загварыг амжилттай устгалаа');
        // if (!this.props.currentProduct.error) this.props.history.push({ pathname: '/products' });
        // console.log('OK', body, this.props.productDelete);

        this.setState({
          formModal: false,
          formData: {},
        });
        this.refresh();
      },
      onCancel: () => {
        console.log('Cancel');
      },
    });
  }

  onCreate = () => {
    this.setState({
      formModal: true,
      formData: {},
    });
  }

  formSubmit = () => {
    this.setState({
      formModal: false,
      formData: {},
    });
  }

  formCancel = () => {
    this.setState({
      formModal: false,
      formData: {},
    });
  }

  submit = async ({ formData }) => {
    await this.props.add({ body: formData });

    this.setState({
      formModal: false,
      formData: {},
    });
    this.refresh();
  }

  getFormOption = () => ({
    schema: {
      title: 'Form',
      type: 'object',
      required: ['type'],
      column: 12,
      properties: {
        type: {
          type: 'string',
          label: 'Төрөл',
          options: typeOptions,
        },
      },
      dependencies: {
        type: {
          oneOf: [
            {
              properties: {
                type: {
                  enum: [
                    'category',
                  ],
                },
                relation_id: {
                  type: 'number',
                  label: 'Категори',
                  options: this.props.categories,
                },
              },
              required: [
                'relation_id',
              ],
            },
            {
              properties: {
                type: {
                  enum: [
                    'category-sub',
                  ],
                },
                relation_id: {
                  type: 'number',
                  label: 'Категори',
                  options: this.props.categories,
                },
              },
              required: [
                'relation_id',
              ],
            },
          ],
        },
      },
    },
    uiSchema: {
      type: {
        "ui:widget": "select",
      },
      // relation_id: {
      //   "ui:widget": "nested-select2",
      // },
      relation_id: {
        "ui:widget": "cascader2",
      },
    },
  })

  breadcrumb = (
    <div className={styles.pageTop}>
      <Breadcrumb className={styles.Topbread}>
        <Breadcrumb.Item>
          <Link to="/">Нүүр</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          Загвар
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  )

  render() {
    return (
      <PageHeaderLayout content={this.breadcrumb}>
        <Row gutter={30}>
          <Col span={24}>
            <Card bordered >
              <div className={styles.cardContainer}>
                <div className={styles.action}>
                  <Button onClick={() => this.onCreate()} icon="plus">Загвар нэмэх</Button>
                </div>
                <SortableList
                  helperClass={`${styles.helper} ${styles.stylizedHelper}`}
                  items={this.props.home.data || []}
                  onSortEnd={({ oldIndex, newIndex }) => this.onSortEnd({ oldIndex, newIndex })}
                  onDelete={this.onDelete}
                  useDragHandle
                />
              </div>
              {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}
            </Card>
          </Col>
        </Row>
        <Modal
          title="Нэмэх"
          visible={this.state.formModal}
          onOk={this.formSubmit}
          width={800}
          onCancel={this.formCancel}
          footer={false}
        >
          {
            this.state.formModal ?
              <Form
                form={this.getFormOption()}
                data={this.state.formData}
                dataParams={{ body: { id: undefined } }}
                onSubmit={this.submit}
              /> : null
          }
        </Modal>
      </PageHeaderLayout>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  home: state.home,
  events: state.global.events,
  // categories: state.category.all.list,
  categories: state.category.all.data,
});

const mapDispatchToProps = {
  list: Home.list,
  add: Home.add,
  remove: Home.remove,
  order: Home.order,
  changeOrder: Home.changeOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);



// WEBPACK FOOTER //
// ./src/containers/Homepage/index.js